import { put, select, delay } from "redux-saga/effects";
import importer from "common/importer";
/* API ENDPOINTS */
const { logout: herokuLogout } = importer("APIs/users", null);
//
const { okta } = importer("APIs/auth", null);
const { logout: oktaLogout } = okta;
/* ACTIONS */
const UserActions = importer("Stores/Users/Actions");
const AppointmentsActions = importer("Stores/Appointments/Actions");
const DonorsActions = importer("Stores/Donors/Actions");
const CentersActions = importer("Stores/Centers/Actions");
const PaymenstActions = importer("Stores/Payments/Actions");
const WirecardActions = importer("Stores/Wirecard/Actions");
const LoyaltyActions = importer("Stores/Loyalty/Actions");

/* STATE */
const { GetToken, tokens } = importer("Stores/Users/Select", null);
export default function* main({ forceLogout = false }) {
  const token = yield select(GetToken);
  const { id_token } = yield select(tokens);
  try {
    yield put(UserActions.logoutLoading());
    yield herokuLogout(token);
    yield cleanState();
    yield delay(1000);
    const logoutUrl = oktaLogout(id_token);
    yield put(UserActions.logoutSuccess(logoutUrl, forceLogout));
  } catch (error) {
    yield oktaLogout(id_token);
    yield put(UserActions.logoutSuccess(error));
  }
}

function* cleanState() {
  yield put(UserActions.cleanUserState());
  yield put(AppointmentsActions.cleanAppointmentState());
  yield put(DonorsActions.cleanDonorsState());
  yield put(CentersActions.cleanCentersState());
  yield put(PaymenstActions.cleanPaymentState());
  yield put(WirecardActions.cleanWirecardState());
  yield put(LoyaltyActions.cleanLoyaltyDetailsState());
}
